// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: false,
    api : 'https://api.valores.pe.gjbl.com.br/',
    // api : 'https://valores.pe.gjbl.com.br/api/',
    front: 'https://valores.pe.gjbl.com.br/',
    odin : 'https://api.odin.gjbl.com.br/',
    hmr       : false,
    type: 'FORTALEZA-VALORES',
    TIME_MENSAGEM_FINANCEIRO: 8000,
    TIME_MENSAGEM: 5000
};
